export default __webpack_public_path__ + "friends-referral-locales/en-US.bbc21d6c4a09418788bb700f07f1b758.json";